module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./AchievementView.js"));
	}, "AchievementView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AchievementView!./src/pages/Promote/Achievement/AchievementView.js
// module id = 1153
// module chunks = 431